import Vue from 'vue'
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router'
import store from '@/store/store'

import { LOCAL_STORAGE } from '@/utils/LSUtil'
import { AuthService } from '@/services/auth'
import { SET_ROUTER_DATATABLE } from '@/store/MUTATIONS-TYPES'
export * from './ROUTERS'
import { ROUTERS } from './ROUTERS'

const LocaleComponent = {
	render(h: any) {
		return h('router-view')
	}
}

Vue.use(VueRouter)

const routes = [
	{
		path: '',
		name: 'home',
		component: () => import('@/views/Home/Home'),
		meta: {
			requiresAuth: true,
			allowedLead: true,
			title: 'Home'
		}
	},

	{
		path: '/authorize-login',
		name: ROUTERS.LOGIN,
		beforeEnter: () => {
			//localStorage.setItem(LOCAL_STORAGE.APP_CURRENT_ROUTE_BEFORE_AUTHORIZE, router.currentRoute.fullPath)
			AuthService.login()
		}
	},

	{
		path: '/login/silent-refresh',
		redirect: '/authorize-login'
	},

	{
		path: '/login/authorize',
		beforeEnter: async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
			var user = store.state.user
			if (user) {
				var hash = localStorage.getItem(LOCAL_STORAGE.APP_CURRENT_ROUTE_BEFORE_AUTHORIZE)
				localStorage.setItem(LOCAL_STORAGE.APP_CURRENT_ROUTE_BEFORE_AUTHORIZE, '')

				if (hash) next(hash.replace('#/', ''))
				else next({ name: ROUTERS.HOME })
			} else {
				localStorage.clear()
				next({ name: ROUTERS.LOGIN })
			}
		}
	},

	{
		path: '/credito-imobiliario',
		component: LocaleComponent,

		children: [
			{
				path: 'simulador',
				name: ROUTERS.CREDITO_IMOBILIARIO.SIMULADOR.MAIN,
				//@ts-ignore
				component: () => import('@/views/CreditoImobiliario/Simulador/Simulador.vue'),
				meta: {
					title: 'Simulador'
				}
			},
			{
				path: 'simulador/:simulacaoId',
				name: ROUTERS.CREDITO_IMOBILIARIO.SIMULADOR.RESULTADO,
				//@ts-ignore
				component: () => import('@/views/CreditoImobiliario/Simulador/Simulador.vue'),
				meta: {
					title: 'Resultado Simulador'
				}
			},
		{
				path: 'novos-compradores',
				component: LocaleComponent,
				children: [
					{
						path: '',
						meta: {
							isDatatable: true,
							title: 'Novos compradores'
						},
						name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.GERENCIAR,
						component: () => import('@/views/CreditoImobiliario/PreAnalise/PreAnalises')
					},

					{
						path: ':preanaliseId',
						name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.DETALHES,
						//@ts-ignore
						component: () => import('@/views/CreditoImobiliario/PreAnalise/Detalhes/PreAnalysisDetails'),
						meta: {
							title: 'Detalhes do comprador'
						}
					},

					{
						path: ':preanaliseId/formulario/:fornecedorId?',
						name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.FORMULARIO_MULTIBANCOS,
						//@ts-ignore
						// component: () => import('@/views/CreditoImobiliario/PreAnalise/PreencherFormulario/PreencherFormulario.vue')
						component: () => import('@/views/CreditoImobiliario/Multibancos/FormularioMultibancos.tsx'),
						meta: {
							title: 'Preencher Formulário'
						}
					},

					{
						path: 'nova',
						name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.NOVA,
						//@ts-ignore
						component: () => import('@/views/CreditoImobiliario/PreAnalise/Nova/Nova.vue'),
						meta: {
							title: 'Nova Pré-Análise'
						},
						children: [
							{
								name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.RESULTADO,
								path: ':scoreId/:simulacaoId?',
								//@ts-ignore
								component: () => import('@/views/CreditoImobiliario/PreAnalise/Nova/Resultado.vue'),
								meta: {
									title: 'Resultado Pré-Análise'
								}
							}
						]
					}
				]
			}
		]
	},

	// PROPOSTAS
	{
		path: '/propostas',
		component: LocaleComponent,
		meta: {
			requiresAuth: true
		},
		children: [
			{
				path: '',
				name: ROUTERS.PROPOSTAS.LISTA,
				component: () => import('@/views/Propostas/Propostas'),
				meta: {
					isDatatable: true,
					title: 'Minhas Propostas'
				}
			},
			{
				path: ':propostaId/:tab?',
				name: ROUTERS.PROPOSTAS.PROPOSTA,
				component: () => import('@/views/Propostas/Proposta/Proposta'),
				meta: {
					title: 'Detalhes da Proposta'
				}
			}
		]
	},

	{
		path: '/administrativo',
		component: LocaleComponent,
		meta: {
			requiresAuth: false,
			allowedLead: true
		},
		children: [
			{
				path: 'canal-franquia',
				name: ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.CANAL_FRANQUIA,
				component: () => import('@/views/Administrativo/CanalFranquia/CanalFranquia'),
				meta: {
					title: 'Canal Franquia'
				}
			},
			{
				path: 'parceiros',
				component: LocaleComponent,
				meta: {
					isDatatable: true
				},
				children: [
					{
						name: ROUTERS.ADMINISTRATIVO.PARCEIROS,
						path: '',
						meta: {
							title: 'Parceiros'
						},
						component: () => import('@/views/Administrativo/Parceiros/FluxoPadrao/Components/DataTable/DataTable')
					},
					{
						path: 'vinculacao',
						name: ROUTERS.ADMINISTRATIVO.PARCEIROS_VINCULACAO,
						component: () => import('@/views/Administrativo/Parceiros/FluxoPadrao/Vinculacao/Vinculacao'),
						meta: {
							title: 'Vinculação Parceiros'
						}
					}
				]
			},

			{
				path: 'grupo-vincular-parceiro',
				name: ROUTERS.ADMINISTRATIVO.GRUPO_VINCULO_PARCEIRO,
				component: () => import('@/views/Administrativo/Grupo/GrupoGerenciarVinculoParceiro'),
				meta: {
					title: 'Grupo Vincular Parceiro'
				}
			},
			{
				path: 'parametrizacao',
				component: LocaleComponent,
				children: [
					{
						path: 'credito-imobiliario',
						name: ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.CREDITO_IMOBILIARIO,
						component: () => import('@/views/Administrativo/Parametrizacao/CreditoImobiliario/CreditoImobiliario'),
						meta: {
							title: 'Crédito Imobiliário'
						}
					},
					{
						path: 'capitalizacao',
						name: ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.CAPITALIZACAO,
						component: () => import('@/views/Administrativo/Parametrizacao/Capitalizacao/Capitalizacao'),
						meta: {
							title: 'Capitalização'
						}
					},
					{
						path: 'meta-consultores',
						name: ROUTERS.ADMINISTRATIVO.PARAMETRIZACOES.META_CONSULTORES,
						component: () => import('@/views/Administrativo/Parametrizacao/MetaConsultor/MetaConsultor'),
						meta: {
							title: 'Meta Consultores'
						}
					}
				]
			},
			{
				path: 'rotinas',
				component: LocaleComponent,
				children: [
					{
						path: 'migracao-Responsavel ',
						name: ROUTERS.ADMINISTRATIVO.ROTINAS.MIGRACAO.RESPONSAVEL,
						component: () => import('@/views/Administrativo/Rotina/Migracao/ResponsavelProposta'),
						meta: {
							title: 'Rotinas - Responsável Proposta'
						}
					},
					{
						path: 'migracao-franquia-proposta ',
						name: ROUTERS.ADMINISTRATIVO.ROTINAS.MIGRACAO.FRANQUIA,
						component: () => import('@/views/Administrativo/Rotina/Migracao/PropostaFranquia'),
						meta: {
							title: 'Rotinas - Proposta Franquia'
						}
					},
					{
						path: 'migracao-analista-proposta ',
						name: ROUTERS.ADMINISTRATIVO.ROTINAS.MIGRACAO.ANALISTA,
						component: () => import('@/views/Administrativo/Rotina/Migracao/PropostaAnalista'),
						meta: {
							title: 'Rotinas - Proposta Analista'
						}
					}
				]
			},
			{
				path: 'usuarios',
				name: ROUTERS.ADMINISTRATIVO.USUARIOS,
				component: () => import('@/views/Administrativo/Usuario/Usuario'),
				meta: {
					title: 'Cadastro de Usuários',
					isDatatable: true
				}
			},
			{
				path: 'acionamento',
				name: ROUTERS.ADMINISTRATIVO.ACIONAMENTO,
				component: () => import('@/views/Administrativo/Acionamento/Acionamento'),
				meta: {
					title: 'Acionamento'
				}
			}
		]
	},
	{
		path: '/dashboard',
		component: LocaleComponent,
		children: [
			{
				name: ROUTERS.DASHBOARD.FRANQUIA,
				path: 'franquias',
				meta: {
					isDatatable: true,
					title: 'Dashboard Franquia'
				},
				component: () => import('@/views/Dashboard/Franquia')
			},
			{
				name: ROUTERS.DASHBOARD.ANALISTA_CREDITO_IMOBILIARIO,
				path: 'creditoimobiliario',
				meta: {
					isDatatable: true,
					title: 'Dashboard Crédito Imobiliário'
				},
				component: () => import('@/views/Dashboard/AnalistaCreditoImobiliario')
			},
			{
				name: ROUTERS.DASHBOARD.PRODUTIVIDADE,
				path: 'produtividade',
				meta: {
					isDatatable: true,
					title: 'Dashboard Produtividade'
				},
				component: () => import('@/views/Dashboard/RankingProdutividade')
			}
		]
	},

	{
		path: '/preview-forms',
		component: () => import('@/views/Demo')
	},
	{
		path: '/closing/minutas-report',
		component: LocaleComponent,
		children: [
			{
				path: '',
				name: ROUTERS.CLOSING_MINUTAS_REPORT,
				component: () => import('@/views/Closing/MinutasReport/MinutasReport'),
				meta: {
					title: 'Relatório - Acompanhamento de Minutas'
				}
			}
		]
	},
	{
		path: '/closing/:tab?',
		component: LocaleComponent,
		children: [
			{
				path: '',
				name: ROUTERS.CLOSING,
				component: () => import('@/views/Closing/Closings'),
				meta: {
					title: 'Fechamento Financeiro'
				}
			}
		]
	},

	{
		path: '/account',
		component: LocaleComponent,
		children: [
			{
				path: '/select-user',
				name: ROUTERS.ACCOUNT.SELECT_USER,
				component: () => import('@/views/Account/SelectUser/SelectUser'),
				meta: {
					title: 'Home'
				}
			}
		]
	}
] as RouteConfig[]

const router = new VueRouter({
	routes
})

router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
	const { state, commit } = store

	commit(SET_ROUTER_DATATABLE, to.meta?.isDatatable)

	if (state.user?.isLead && !to.matched.some((record: any) => record.meta.allowedLead)) {
		next({
			name: 'queroSerParceiro',
			query: { page: to.name }
		})
		return
	}

	const { uid } = to.query
	if (uid != null) {
		var result = await AuthService.authorizeByEncryptedId(uid?.toString())
		var userLogin = await AuthService.getUserByToken(result)

		userLogin.access_token = result
		await AuthService.setUserStore(userLogin)
	}

	if (to.matched.some((record: any) => record.meta.requiresAuth)) {
		// switch (window.location.host) {
		// 	//case 'experimente.atta.com.vc':
		// 	case 'localhost:8080':
		// 		next()
		// 	//return
		// }

		if (state.user?.id === null) {
			try {
				var user = await AuthService.setUserStore()

				if (user) {
					next()
				} else {
					next({ name: ROUTERS.LOGIN })
				}
			} catch {
				next({ name: ROUTERS.LOGIN })
			}
		}

		next()
	} else {
		next()
	}
})

router.beforeResolve((to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
	// update page title before navigation, so Amplitude can track the page view
	const title = to.meta?.title
	document.title = title ? `iSolve | ${title}` : 'iSolve | Financiamento'

	next()
})

export default router
